import { HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Version } from '../services/shared-data.service';
import { RepoHttpClient } from './repo-http-client';

@Injectable({ providedIn: 'root' })
export class RepoDeploymentService {
    constructor(private httpClient: RepoHttpClient) {}

    async GetLatestVersion() {
        const d = new Date();
        const headers = new HttpHeaders().set('X-HIDEOVERLAY', '1');
        const response = await this.httpClient.get('/version.json?d=' + d.valueOf(), {
            headers,
        });
        return response.body as Version;
    }

    GetCurrentVersion() {
        return {
            number: window.APP_CONFIG.appVersion,
            date: window.APP_CONFIG.appVersionDate,
        } as Version;
    }
}
